import { createEvent, createStore } from 'effector';

import {
    DEFAULT_ACCESSIBILITY_SELECTION,
    DEFAULT_FOCUS_HIGHLIGHT_SELECTION,
    type AccessibilitySelection,
    type FocusHighlightSelection,
} from './logic';

export const accessibilityHydrated = createEvent<AccessibilitySelection>();
export const accessibilityChanged = createEvent<AccessibilitySelection>();
export const focusHighlightHydrated = createEvent<FocusHighlightSelection>();
export const focusHighlightChanged = createEvent<FocusHighlightSelection>();

export const $accessibilitySelection = createStore<AccessibilitySelection>(DEFAULT_ACCESSIBILITY_SELECTION)
    .on(accessibilityHydrated, (_state, payload) => payload)
    .on(accessibilityChanged, (_state, payload) => payload);

export const $focusHighlightSelection = createStore<FocusHighlightSelection>(DEFAULT_FOCUS_HIGHLIGHT_SELECTION)
    .on(focusHighlightHydrated, (_state, payload) => payload)
    .on(focusHighlightChanged, (_state, payload) => payload);
